/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCharactersCharacterIdMailRecipient } from './GetCharactersCharacterIdMailRecipient';
import {
    GetCharactersCharacterIdMailRecipientFromJSON,
    GetCharactersCharacterIdMailRecipientFromJSONTyped,
    GetCharactersCharacterIdMailRecipientToJSON,
    GetCharactersCharacterIdMailRecipientToJSONTyped,
} from './GetCharactersCharacterIdMailRecipient';

/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdMail200Ok
 */
export interface GetCharactersCharacterIdMail200Ok {
    /**
     * From whom the mail was sent
     * @type {number}
     * @memberof GetCharactersCharacterIdMail200Ok
     */
    from?: number;
    /**
     * is_read boolean
     * @type {boolean}
     * @memberof GetCharactersCharacterIdMail200Ok
     */
    isRead?: boolean;
    /**
     * labels array
     * @type {Set<number>}
     * @memberof GetCharactersCharacterIdMail200Ok
     */
    labels?: Set<number>;
    /**
     * mail_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdMail200Ok
     */
    mailId?: number;
    /**
     * Recipients of the mail
     * @type {Set<GetCharactersCharacterIdMailRecipient>}
     * @memberof GetCharactersCharacterIdMail200Ok
     */
    recipients?: Set<GetCharactersCharacterIdMailRecipient>;
    /**
     * Mail subject
     * @type {string}
     * @memberof GetCharactersCharacterIdMail200Ok
     */
    subject?: string;
    /**
     * When the mail was sent
     * @type {Date}
     * @memberof GetCharactersCharacterIdMail200Ok
     */
    timestamp?: Date;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdMail200Ok interface.
 */
export function instanceOfGetCharactersCharacterIdMail200Ok(value: object): value is GetCharactersCharacterIdMail200Ok {
    return true;
}

export function GetCharactersCharacterIdMail200OkFromJSON(json: any): GetCharactersCharacterIdMail200Ok {
    return GetCharactersCharacterIdMail200OkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdMail200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdMail200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'] == null ? undefined : json['from'],
        'isRead': json['is_read'] == null ? undefined : json['is_read'],
        'labels': json['labels'] == null ? undefined : new Set(json['labels']),
        'mailId': json['mail_id'] == null ? undefined : json['mail_id'],
        'recipients': json['recipients'] == null ? undefined : (new Set((json['recipients'] as Array<any>).map(GetCharactersCharacterIdMailRecipientFromJSON))),
        'subject': json['subject'] == null ? undefined : json['subject'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
    };
}

export function GetCharactersCharacterIdMail200OkToJSON(json: any): GetCharactersCharacterIdMail200Ok {
    return GetCharactersCharacterIdMail200OkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdMail200OkToJSONTyped(value?: GetCharactersCharacterIdMail200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'],
        'is_read': value['isRead'],
        'labels': value['labels'] == null ? undefined : Array.from(value['labels'] as Set<any>),
        'mail_id': value['mailId'],
        'recipients': value['recipients'] == null ? undefined : (Array.from(value['recipients'] as Set<any>).map(GetCharactersCharacterIdMailRecipientToJSON)),
        'subject': value['subject'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
    };
}

